import { Component, inject } from '@angular/core';
import { AuthService } from '../../auth/services/auth.service';
import { initFlowbite } from 'flowbite';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-menu-admin',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './menu-admin.component.html',
  styleUrl: './menu-admin.component.scss'
})
export class MenuAdminComponent {

  authService = inject(AuthService);
  user: any;

  ngOnInit(): void {
    initFlowbite();

    this.authService.user$.subscribe(response => {
      if (response) {
        this.user = response;
      }
    });
  }

  logoOut() {
    this.authService.logoOut();
  }

}